import { TrevorIcon } from '@trevor/ui-components';
import React, { FC } from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
  background: var(--color-interface-neutral-light);
  border: 1px solid var(--color-interface-layout-normal);
  border-radius: 4px;
  height: var(--spacing-xl);
  width: var(--spacing-xl);
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-interface-secondary-normal);
  margin: 4px;

  :hover,
  :focus {
    border: 1px solid var(--color-interface-secondary-lighter);
    box-shadow: var(--elevation-soft);
    width: 40px;
    height: 40px;
    margin: 0;
    transition: all var(--transition-normal);
  }
`;

export const PlusButton: FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = ({
  children,
  ...props
}) => {
  return (
    <StyledButton {...props}>
      <TrevorIcon name="plus-small" />
      {children}
    </StyledButton>
  );
};
